/**
 * Pumper OOS-flash safety net for wolfworkwear.com (Palo Alto theme).
 * If button text contains the theme's "Sold Out" string AND the URL/hidden-input
 * variant is actually in stock per pumper.productVariants, revert to "Add to Cart".
 * Doesn't capture SSR text (SSR may have rendered Sold Out for a redirected OOS URL).
 */
(function () {
  'use strict';
  if (window.__pmprAtcGuard) return;
  window.__pmprAtcGuard = true;

  var SEL_BTN = 'form.product__form button.product__submit__add';
  var SEL_INPUT = 'form.product__form input[name="id"]';

  function getStrings() {
    var s = (window.theme && window.theme.strings) || {};
    return {
      soldOut: s.sold_out || 'Sold Out',
      addToCart: s.add_to_cart || 'Add to Cart'
    };
  }

  function isUrlVariantAvailable() {
    var hidden = document.querySelector(SEL_INPUT);
    var pumper = window.pumper;
    if (!hidden || !pumper || !pumper.productVariants) return null;
    var v = pumper.productVariants.find(function (x) {
      return String(x.id) === String(hidden.value);
    });
    return v ? !!v.available : null;
  }

  function revertIfWidgetClobbered() {
    var btn = document.querySelector(SEL_BTN);
    if (!btn) return;
    var avail = isUrlVariantAvailable();
    if (avail !== true) return;
    var strings = getStrings();
    var current = (btn.textContent || '').trim();
    if (!current.toLowerCase().includes(strings.soldOut.toLowerCase())) return;
    btn.textContent = strings.addToCart;
    btn.removeAttribute('data-notification-popup');
  }

  function start() {
    revertIfWidgetClobbered();
    var obs = new MutationObserver(revertIfWidgetClobbered);
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-notification-popup']
    });
    [200, 600, 1500, 3000, 5000].forEach(function (ms) {
      setTimeout(revertIfWidgetClobbered, ms);
    });
    window.addEventListener('beforeunload', function () { obs.disconnect(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
